import { render, staticRenderFns } from "./CorporationK.vue?vue&type=template&id=5709d593&scoped=true"
import script from "./CorporationK.vue?vue&type=script&lang=js"
export * from "./CorporationK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709d593",
  null
  
)

export default component.exports